"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_BULK_ASSERTIONS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_BULK_ASSERTIONS = (0, gql_1.gql)(`
   mutation CreateBulkAssertions($batchAssertions: ProductBatchAssertionsInput!) {
   productBatchAssertions(batchAssertions: $batchAssertions) {
      success
      error
    }
   }
`);
